import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "form-group mb-3" }
const _hoisted_3 = {
  for: "securityAnswer",
  class: "form-label"
}
const _hoisted_4 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { class: "form-group mt-4" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.user.securityQuestion), 1),
        _createVNode(_component_ToolTip, { tooltipText: "Answer your security question and click next to continue." })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.securityAnswer) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideErrors('securityAnswer'))),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSubmitDisabled = false)),
        id: "securityAnswer",
        class: _normalizeClass(["form-control", _ctx.v$.user.securityAnswer.$error ? 'is-invalid' : 'input-text'])
      }, null, 34), [
        [_vModelText, _ctx.user.securityAnswer]
      ]),
      (_ctx.v$.user.securityAnswer.$error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.v$.user.securityAnswer.$invalid)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({ 'is-invalid': _ctx.v$.user.securityAnswer.$error })
                }, " Please enter a valid security question answer ", 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "form-check-input",
        id: "rememberDevice",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rememberDevice) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.rememberDevice]
      ]),
      _createTextVNode(" Please remember this device ")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        name: "backBtn",
        class: "btn back-btn btn-primary w-20",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.backButtonHandler && _ctx.backButtonHandler(...args)))
      }, " BACK "),
      _createElementVNode("button", {
        disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
        class: _normalizeClass(["btn", [_ctx.buttonDesign()]]),
        id: "button-continue",
        type: "submit",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSubmit()))
      }, " CONTINUE ", 10, _hoisted_7)
    ])
  ], 64))
}